function trimStr(v) {
  return String(v == null ? '' : v).trim()
}

export function uniqueSelectOptions(values) {
  return [...new Set(values.map(trimStr).filter(Boolean))]
    .sort((a, b) => a.localeCompare(b))
    .map((v) => ({ label: v, value: v }))
}

export function typesFromRows(rows) {
  return uniqueSelectOptions(rows.map((r) => r.type))
}

export function makesFromRows(rows, type) {
  const t = trimStr(type)
  const filtered = t
    ? rows.filter((r) => trimStr(r.type) === t)
    : rows
  return uniqueSelectOptions(filtered.map((r) => r.make))
}

export function modelsFromRows(rows, type, make) {
  const t = trimStr(type)
  const m = trimStr(make)
  let filtered = rows
  if (t) filtered = filtered.filter((r) => trimStr(r.type) === t)
  if (m) filtered = filtered.filter((r) => trimStr(r.make) === m)
  return uniqueSelectOptions(filtered.map((r) => r.model))
}

export function deviceMetadataComboKey(type, make, model) {
  return `${trimStr(type)}|${trimStr(make)}|${trimStr(model)}`
}

export function deviceMetadataValidComboSet(rows) {
  return new Set(rows.map((r) => deviceMetadataComboKey(r.type, r.make, r.model)))
}

/** Resolve device `type` from metadata when only make/model are stored (e.g. facility assets). */
export function inferTypeFromMakeModel(rows, make, model) {
  const m = trimStr(make)
  const mo = trimStr(model)
  if (!m || !mo) return ''
  const row = rows.find(
    (r) => trimStr(r.make) === m && trimStr(r.model) === mo,
  )
  return row ? trimStr(row.type) : ''
}
